import react from 'react'
import {Dimensions} from "react-native";
 const width = Dimensions.get("window").width
export const CONSTANTS  = {
        PROFILE_CARD_WIDTH : width > 1024 && width < 1180 ? width/1.3 : width > 1180 && width < 1480 ?  width/1.35 : width/1.63,
        PROFILE_TEXT_WIDTH : width > 200 && width < 300 ? 6 : width > 300 && width < 500 ?  7 : width > 500 && width <= 767 ? 9 : width > 767 && width < 1024 ?  12 : width > 1024 && width < 1180 ? 14 : width > 1180 && width < 1480 ?  16 : 18,
        PROFILE_INPUT_WIDTH :width < 200 ? 80 : width > 200 && width < 300 ? 120 : width > 300 && width < 500 ? 200 : width > 500 && width < 750 ? 240 :width > 1024 && width < 1180 ? 200 : width > 1180 &&width < 1480 ?  240 : 265.7,
        FONTSIZES:{
            DESK18:width > 200 && width < 300 ? 8 : width > 300 && width < 400 ?  10 : width > 400 && width <= 767 ? 12 : width > 767 && width < 1024 ?  16 :  width > 1024 && width < 1180 ? 14 : width > 1180 && width < 1480 ?  16 : 16,
        }
      
}